'use client';

import { Tooltip as TooltipProvider } from 'react-tooltip';
import type { PropsWithChildren } from 'react';

type TooltipProps = PropsWithChildren<{
  id: string;
}>;

export const Tooltip = ({ id, children }: TooltipProps) => {
  return (
    <TooltipProvider
      disableStyleInjection
      id={id}
      className="text-body-2 w-10/12 max-w-sm rounded-rad-a border border-info bg-white p-b shadow z-50"
      opacity={1}
      noArrow
      delayShow={400}
      delayHide={1200}
    >
      {children}
    </TooltipProvider>
  );
};
